"use strict";
// (C) 2021 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.BuiltInWidgetTypes = void 0;
/**
 * List of built-in widget types. These type names are reserved and must not be used by custom widgets.
 *
 * @alpha
 */
exports.BuiltInWidgetTypes = ["kpi", "insight"];
//# sourceMappingURL=baseWidget.js.map